export default {
  PEOPLE_FETCH_START: 'PEOPLE_FETCH_START',
  PEOPLE_FETCH_SUCCESS: 'PEOPLE_FETCH_SUCCESS',
  PEOPLE_FETCH_FAILURE: 'PEOPLE_FETCH_FAILURE',

  PEOPLE_MAIL_TO_ID_UPDATE: 'PEOPLE_MAIL_TO_ID_UPDATE',
}
